"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OPTIONS = void 0;
const react_1 = __importDefault(require("react"));
const base_1 = require("../../core/base");
const { TextNode } = base_1.RCNode;
exports.DEFAULT_OPTIONS = {
    padding: [20, 0, 0, 50],
    node: {
        type: 'react',
        style: {
            component: (data) => react_1.default.createElement(TextNode, { type: "filled", text: data.id }),
            size: [100, 40],
            ports: [{ placement: 'left' }, { placement: 'right' }],
        },
        state: {
            active: {
                halo: false,
            },
            selected: {
                halo: false,
            },
        },
    },
    edge: {
        type: 'cubic-horizontal',
        style: {
            strokeOpacity: 0.5,
        },
        state: {
            active: {
                strokeOpacity: 1,
            },
        },
    },
    layout: {
        type: 'antv-dagre',
        rankdir: 'LR',
    },
    transforms: ['translate-react-node-origin'],
};
